import { ScoutWriteMode } from "generated-graphql/graphql";

/**
 * Oak-side Scout write-mode values. Prefer the generated GraphQL enum so
 * Apollo input types (`SendScoutMessageInput.writeMode`) accept values without
 * widening/casting. Runtime/persistence still uses lowercase strings; the API
 * maps at the resolver boundary.
 */
export { ScoutWriteMode };
export type ScoutWriteModeGql = ScoutWriteMode;

export const SCOUT_WRITE_MODE_GQL = {
  OFF: ScoutWriteMode.Off,
  ASK: ScoutWriteMode.Ask,
  AUTO: ScoutWriteMode.Auto,
} as const satisfies Record<"OFF" | "ASK" | "AUTO", ScoutWriteMode>;

/** New chats start on Ask when Scout data changes are available. */
export const SCOUT_NEW_CHAT_WRITE_MODE = SCOUT_WRITE_MODE_GQL.ASK;

export const SCOUT_WRITE_MODE_OPTIONS: ReadonlyArray<{
  value: ScoutWriteMode;
  label: string;
}> = [
  { value: ScoutWriteMode.Off, label: "Data editing off" },
  { value: ScoutWriteMode.Ask, label: "Ask before editing" },
  { value: ScoutWriteMode.Auto, label: "Data editing on" },
];
